import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { styles } from './select-styles';
import theme from '../../theme';
export const Select = ({ classes, dataTestId, disabled, isMenuButton, onChange, items = [], name = '', placeholder = 'Select', value = '', height, ...props })=>{
    const generateDisplayedValue = (val)=>{
        const selectedItem = items?.find((item)=>val === item.value);
        if (selectedItem) {
            return selectedItem.label;
        }
        if (val.length > 35) {
            let result = val.substring(0, 30) + '...';
            return result;
        }
        return val;
    };
    const buttonHeight = height || 'auto';
    return /*#__PURE__*/ _jsxs(Menu, {
        autoSelect: false,
        strategy: "fixed",
        children: [
            /*#__PURE__*/ _jsx(MenuButton, {
                height: buttonHeight,
                as: Button,
                disabled: disabled,
                sx: classes?.button ?? (value ? styles.buttonSelected : styles.button),
                rightIcon: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                    sx: classes?.icon ?? styles.icon
                }),
                "data-testid": dataTestId?.trim() ?? 'dropdown',
                _focus: {
                    boxShadow: 'none'
                },
                _expanded: {
                    bg: isMenuButton ? theme.colors.accent[100] : theme.colors.text['light'],
                    border: isMenuButton ? `${theme.borders['1px']} ${theme.colors.accent[100]}` : `${theme.borders['1px']} ${theme.colors.foundation[500]}`
                },
                _hover: {
                    border: isMenuButton ? `${theme.borders['1px']} ${theme.colors.accent[100]}` : `${theme.borders['1px']} ${theme.colors.foundation[400]}`,
                    bg: isMenuButton ? theme.colors.accent[100] : theme.colors.text['light']
                },
                children: generateDisplayedValue(value) || placeholder
            }),
            /*#__PURE__*/ _jsx(Portal, {
                appendToParentPortal: false,
                children: /*#__PURE__*/ _jsx(MenuList, {
                    sx: {
                        ...styles.list,
                        zIndex: 5000
                    },
                    children: items?.map((item, key)=>/*#__PURE__*/ _jsx(MenuItem, {
                            sx: item?.value === value || item.label === value ? styles.itemSelected : styles.item,
                            style: {
                                minHeight: '30px',
                                fontSize: '14.5px'
                            },
                            value: item?.value,
                            name: name,
                            onClick: onChange,
                            "data-testid": item?.value?.toString().trim(),
                            children: item?.label
                        }, key))
                })
            })
        ]
    });
};
Select.displayName = 'Select';
